export default __webpack_public_path__ + "static/media/scrum.b558f2e9.PNG";